/* eslint-disable operator-linebreak */
/**
 * // TODO：改写字典结构，优化图片查找性能
 * @file 图片懒加载指令 v-lazy
 */

import isPlainObject from 'lodash/isPlainObject'
import debounce from 'lodash/debounce'
import device from './device'

/**
 * @type {window} window
 */
const w = window
/**
 * @type {boolean} 初始化
 */
let _init = false
/**
 * @type {HTMLElement[]} 待加载元素
 */
const lazyImages = []
/**
 * @type {HTMLElement[]} 自定义滚动元素
 */
const customerScrollElement = []
/**
 * @type {boolean} 开始赖加载
 */
const closeLazy = device.isAndroid && +device.androidVersion <= 6

// eslint-disable-next-line consistent-return
function setSrc(el, url) {
  const type = el.tagName.toLowerCase() === 'img' ? 'src' : 'url'
  if (type === 'src') {
    el.setAttribute('src', url)
  } else {
    el.style.backgroundImage = `url(${url})`
  }
}

export function checkImageVisible(el) {
  return (
    el.getBoundingClientRect().top <= w.innerHeight &&
    el.getBoundingClientRect().bottom >= 0 &&
    el.getBoundingClientRect().left < w.innerWidth
  )
}

function scrollHandler() {
  for (let i = 0; i < lazyImages.length; i++) {
    const el = lazyImages[i]
    if (checkImageVisible(el)) {
      const url = el.getAttribute('data-url')
      setSrc(el, url)
      lazyImages.splice(i, 1)
      i--
    }
  }
}

const debounceScrollHandler = debounce(scrollHandler, 1000)

function scrollEventInit() {
  w.addEventListener('scroll', scrollHandler)
}

function addScrollElement(el) {
  customerScrollElement.push(el)
  el.addEventListener('scroll', scrollHandler)
}

// eslint-disable-next-line consistent-return
function imageInit(option) {
  const { immediately, el, url } = option
  if (closeLazy || immediately || checkImageVisible(el)) {
    return setSrc(el, url)
  }
  el.setAttribute('data-url', url)
  lazyImages.push(el)

  // 避免异步渲染时，计算不准确
  debounceScrollHandler()
}

const lazyDirective = {
  // eslint-disable-next-line consistent-return
  inserted(el, binding) {
    const { value, modifiers } = binding
    const { i, s } = modifiers
    if (s) {
      return addScrollElement(el)
    }

    if (!value) {
      return null
    }

    let option = {
      el,
      immediately: !!i,
    }

    if (typeof value === 'string') {
      option.url = value
    } else if (isPlainObject(value)) {
      option = {
        ...option,
        url: value.url,
        immediately: !!value.i,
      }
    } else {
      return null
    }
    imageInit(option)
  },
  // eslint-disable-next-line consistent-return
  unbind(el, binding) {
    const { modifiers } = binding
    if (modifiers.s) {
      customerScrollElement.forEach((value, index) => {
        customerScrollElement.splice(index, 1)
      })
      return el.removeEventListener('scroll', scrollHandler)
    }
    lazyImages.forEach((value, index) => {
      if (value === el) {
        lazyImages.splice(index, 1)
      }
    })
  },
}

function install(Vue) {
  if (!_init) {
    scrollEventInit()
    _init = true
  }
  Vue.directive('lazy', lazyDirective)
}

export default {
  install,
}
